import URLs, { BASE_URL } from "../constants/Apis";
import api from "../api/api";

let headers = {
  "Content-Type": "application/json",
};

const prefixedUrls = Object.keys(URLs).reduce((acc, key) => {
  acc[key] = BASE_URL + URLs[key];
  return acc;
}, {});

// console.log(URLs, "Urls");
export default {
  dashboard: {
    getDetails: () =>
      api.get(URLs.DashboardData).then((response) => {
        return response.data;
      }),
    get_ecas_demographic_graph_data: () =>
      api.get(URLs.get_ecas_demographic_graph_data).then((response) => {
        return response.data;
      }),
  },

  login: (data) =>
    api.post(URLs.login, data, { headers: headers }).then((response) => {
      return response;
    }),
  check_user_logged_for_first_time: () =>
    api.get(URLs.check_user_logged_for_first_time).then((response) => {
      return response.data;
    }),
  changePassword: {
    change: (data) =>
      api.post(URLs.changePassword, data).then((response) => {
        return response;
      }),
  },

  ambassadors: {
    list: () =>
      api.get(URLs.studentList).then((response) => {
        return response.data;
      }),
  },

  participants: {
    get_eals_frs_list: (data) =>
      api.get(URLs.get_eals_frs_list + data).then((response) => {
        return response.data;
      }),
    get_ares_score_list: (data) =>
      api.get(URLs.get_ares_score_list + data).then((response) => {
        return response.data;
      }),
    get_demographic_details: (url) =>
      api.get(URLs.getDemographicDetails + url).then((response) => {
        return response;
      }),
    get_radcliff_demographic_details: (url) =>
      api.get(URLs.get_radcliff_demographic_details + url).then((response) => {
        return response.data;
      }),
    getParticipantList: (url) =>
      api.get(URLs.ParticipantList + url).then((response) => {
        return response;
      }),
    getReminderDetails: (url) =>
      api.get(url).then((response) => {
        return response;
      }),
    openPatientPortal: (url) =>
      api.get(URLs.openPatientPortal + url).then((response) => {
        return response.data;
      }),
    get_client_code: (url) =>
      api.get(URLs.get_client_code + url).then((response) => {
        return response.data;
      }),
  },
  ecas: {
    dashboard: () =>
      api.get(URLs.get_ecas_forms_dashboard_counts).then((response) => {
        return response.data;
      }),
    list: () =>
      api.get(URLs.get_ecas_form_list).then((response) => {
        return response.data;
      }),
    get_details_by_id: (params) =>
      api.get(URLs.get_ecas_form_details + params).then((response) => {
        return response;
      }),
  },

  reports: {
    alsReportPieChartData: () =>
      api.get(URLs.getAlsReportData).then((response) => {
        return response.data;
      }),
  },

  slp_rating: {
    get_participants: (data) =>
      api.get(URLs.get_participants_for_slp_rating + data).then((response) => {
        return response.data;
      }),
  },
  session_entry: {
    get_details_with_radcliff_sessions: (data) =>
      api
        .post(URLs.get_details_with_radcliff_sessions, data)
        .then((response) => {
          return response.data;
        }),
  },
  content_library: {
    list: (param) =>
      api.get(URLs.get_content_library_list + param).then((response) => {
        return response.data;
      }),
  },
  slp_substudy: {
    dashboard: () =>
      api.get(URLs.get_slp_substudy_dashboard_counts).then((response) => {
        return response.data;
      }),
  },
  feature_roadmap: {
    list: (param) =>
      api.get(URLs.get_feature_roadmap_list + param).then((response) => {
        return response.data;
      }),
    save: (params) =>
      api.post(URLs.save_new_feature_roadmap, params).then((response) => {
        return response.data;
      }),
    vote: (params) =>
      api.post(URLs.give_vote_for_feature, params).then((response) => {
        return response.data;
      }),
    vote_user_list: (param) =>
      api.get(URLs.get_total_upvote_user_list + param).then((response) => {
        return response.data;
      }),
  },
  speech_study: {
    all_demographics_chart_data: () =>
      api.get(URLs.get_all_demographic_chart_data).then((response) => {
        return response.data;
      }),
  },
  radcliff_study: {
    get_cumulative_chart_data: () =>
      api.get(URLs.get_cumulative_chart_data).then((response) => {
        return response.data;
      }),
    get_radcliff_demographics_chart_data: () =>
      api.get(URLs.get_radcliff_demographics_chart_data).then((response) => {
        return response.data;
      }),
    get_cpib_form_list: (data) =>
      api.post(URLs.get_cpib_form_list, data).then((response) => {
        return response.data;
      }),
  },
  consortia_upload: {
    get: (param) =>
      api.get(URLs.get_consortia_upload_list + param).then((response) => {
        return response.data;
      }),
    add: (params) =>
      api.post(URLs.add_consortia_upload, params).then((response) => {
        return response.data;
      }),
    update: (params) =>
      api.post(URLs.update_consortia_upload, params).then((response) => {
        return response.data;
      }),
  },
  audit_logs: {
    view_dashboard: () =>
      api.get(URLs.view_dashboard).then((response) => {
        return response.data;
      }),
    view_content_library_page: () =>
      api.get(URLs.view_content_library_page).then((response) => {
        return response.data;
      }),
    view_consortia_workspace: () =>
      api.get(URLs.view_consortia_workspace).then((response) => {
        return response.data;
      }),
    view_add_consortia_requests: () =>
      api.get(URLs.view_add_consortia_requests).then((response) => {
        return response.data;
      }),
    view_add_consortia_upload: () =>
      api.get(URLs.view_add_consortia_upload).then((response) => {
        return response.data;
      }),
    view_edit_consortia_upload_record: (param) =>
      api
        .get(URLs.view_edit_consortia_upload_record + param)
        .then((response) => {
          return response.data;
        }),
    view_consortia_upload_details: (param) =>
      api.get(URLs.view_consortia_upload_details + param).then((response) => {
        return response.data;
      }),
    view_speech_study_report_details: () =>
      api.get(URLs.view_speech_study_report_details).then((response) => {
        return response.data;
      }),
    view_content_library_record_details: (data) =>
      api
        .get(URLs.view_content_library_record_details + data)
        .then((response) => {
          return response.data;
        }),
    view_content_library_full_description: (data) =>
      api
        .get(URLs.view_content_library_full_description + data)
        .then((response) => {
          return response.data;
        }),
    view_content_library_chatbot: (data) =>
      api.get(URLs.view_content_library_chatbot + data).then((response) => {
        return response.data;
      }),
  },
  forgotPassword: {
    sendOtp: (data) =>
      api.post(URLs.sendForgotPasswordOtp, data).then((response) => {
        return response.data;
      }),
    verifyOtp: (data) =>
      api.post(URLs.verifyForgotOtp, data).then((response) => {
        return response.data;
      }),
    resetPassword: (data) =>
      api.post(URLs.resetPassword, data).then((response) => {
        return response.data;
      }),
  },
  myStudies:{
    getParticipantList:(params)=>{
      return api.get(URLs.get_rapa_participant_list+params).then((response) => {
        console.log("response----->",response);
        return response.data;
      })  
    }
  }
  ,
  get_consortia_workspace_list: () =>
    api.get(URLs.get_consortia_workspace_list).then((response) => {
      return response.data;
    }),
};
